// httpService.js
import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";

// Create an Axios instance with the base URL from your environment variables.
const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
});

// Request interceptor: Attach the token from sessionStorage (if available) to every request.
http.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: Log unexpected errors and show a toast notification.
http.interceptors.response.use(
  (response) => response,
  (error) => {
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedError) {
      logger.log(error);
      toast.error("An unexpected error occurred.");
    }

    return Promise.reject(error);
  }
);

// Optionally, if you want to set the token manually (and store it in sessionStorage):
function setJwt(jwt) {
  sessionStorage.setItem("token", jwt);
  // Also update the default header for immediate subsequent requests.
  http.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
}

// Export an object that exposes the HTTP methods you need.
export default {
  get: http.get,
  post: http.post,
  put: http.put,
  patch: http.patch,
  delete: http.delete,
  setJwt,
};
